import { accessPermitRelationTypesEnum } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { selectList as accessPermitsList } from "sources/books/accessPermits";
import { list as transportColumnsList } from "sources/books/transportColumns";

const config = {
    firstName: {
        // field
        label: "Имя",
        inputProps: { name: "firstName" },
        validators: [requiredField],
        required: true,
        labelWrapper: "col-12 col-form-label col-form-label-sm text-muted",
        fieldWrapper: "col-12",
    },
    lastName: {
        // field
        label: "Фамилия",
        inputProps: { name: "lastName" },
        validators: [requiredField],
        required: true,
        labelWrapper: "col-12 col-form-label col-form-label-sm text-muted",
        fieldWrapper: "col-12",
    },
    patronymic: {
        // field
        label: "Отчество",
        inputProps: { name: "patronymic" },
        labelWrapper: "col-12 col-form-label col-form-label-sm text-muted",
        fieldWrapper: "col-12",
    },
    phoneNumber: {
        // field
        label: "Телефон",
        type: "phone",
        inputProps: { name: "phoneNumber" },
        validators: [requiredField],
        required: true,
        labelWrapper: "col-12 col-form-label col-form-label-sm text-muted",
        fieldWrapper: "col-12",
    },
    snils: {
        label: "СНИЛС",
        type: "customMask",
        inputProps: { name: "snils", placeholder: "000-000-000 00" },
        mask: "999-999-999 99",
        maskPlaceholder: "___-___-___ __",
        labelWrapper: "col-12 col-form-label col-form-label-sm text-muted",
        fieldWrapper: "col-12",
        nullIfEmpty: true,
    },
    inn: {
        // field
        label: "ИННФЛ",
        inputProps: { name: "inn", maxLength: 12 },
        labelWrapper: "col-12 col-form-label col-form-label-sm text-muted",
        fieldWrapper: "col-12",
        nullIfEmpty: true,
    },
    transportColumnId: {
        // async-select
        label: "Колонна",
        inputProps: { name: "transportColumnId" },
        url: transportColumnsList,
        propName: "name",
        menuPortalTarget: document.body,
        labelWrapper: "col-12 col-form-label col-form-label-sm text-muted",
        fieldWrapper: "col-12",
    },
    comment: {
        // field
        label: "Cсылки на документы",
        inputProps: { name: "comment" },
        textarea: true,
        labelWrapper: "col-12 col-form-label col-form-label-sm text-muted",
        fieldWrapper: "col-12",
    },
    needsShiftChangeComment: {
        // field
        label: "Необходимость в перецепке/пересменке",
        inputProps: { name: "needsShiftChangeComment" },
        textarea: true,
        nullable: true,
        labelWrapper: "col-12 col-form-label col-form-label-sm text-muted",
        fieldWrapper: "col-12",
    },
    needsUrgentShiftChange: {
        // checkbox
        label: "Срочная необходимость в перецепке/пересменке",
        inputProps: { name: "needsUrgentShiftChange" },
        checkbox: true,
        fieldBeforeLabel: true,
        labelWrapper: "col-auto col-form-label col-form-label-sm pl-0",
        fieldWrapper: "col-auto",
        bWrapper: "row mb-2 align-items-center",
    },
    accessPermitIds: {
        label: "Полученные разрешения",
        isMulti: true,
        inputProps: { name: "accessPermitIds" },
        url: (props) => accessPermitsList({ filter: { relationType: accessPermitRelationTypesEnum.Driver }, ...props }),
        propName: "name",
        menuPortalTarget: document.body,
        labelWrapper: "col-12 col-form-label col-form-label-sm text-muted",
        fieldWrapper: "col-12",
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
